import React from 'react';
import { Box } from '@mui/material';

/**
 * Tier 0: the floor under every table not yet migrated to `ResponsiveTable`.
 *
 * It guarantees only one thing — a wide table scrolls inside its own box instead of forcing the
 * whole page to scroll sideways. Deliberately does not render a view switcher: this page cannot
 * honour a mode change, so it must not offer one.
 */
const ScrollableTable = ({ children }: { children: React.ReactNode }) => (
    <Box data-testid="scrollable-table" sx={{ overflowX: 'auto', maxWidth: '100%', WebkitOverflowScrolling: 'touch' }}>
        {children}
    </Box>
);

export default ScrollableTable;
